import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView, Spacer, Spacing} from '/component/base/Storybook';

import Checked from './Checked';
import Color from './Color';
import Disabled from './Disabled';
import Event from './Event';
import ReadOnly from './ReadOnly';

storiesOf('base', module).add('Checkbox', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Color />
        <Spacer size={24} />
        <Checked />
        <Spacer size={24} />
        <ReadOnly />
        <Spacer size={24} />
        <Disabled />
        <Spacer size={24} />
        <Event />
      </FlexView>
    </Spacing>
  </ScrollView>
));
